import type { RecentParcel } from '../services/api';

const TENDER_TYPE_LABELS: Record<string, string> = {
  sale: 'Sprzedaż',
  lease: 'Dzierżawa',
  auction: 'Przetarg',
  other: 'Inne',
};

function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('pl-PL');
}

function formatPrice(price: number): string {
  return price.toLocaleString('pl-PL') + ' zł';
}

function formatRelativeTime(dateStr: string): string {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffHours < 1) return 'przed chwilą';
  if (diffHours < 24) return `${diffHours}h temu`;
  if (diffDays === 1) return 'wczoraj';
  if (diffDays < 7) return `${diffDays} dni temu`;
  return formatDate(dateStr);
}

type Props = {
  parcels: RecentParcel[];
  loading: boolean;
  error: string | null;
  onParcelClick: (id: string, lat: number, lng: number) => void;
};

export function RecentParcels({ parcels, loading, error, onParcelClick }: Props) {
  return (
    <div className="recent-parcels">
      <h2>Ostatnio dodane</h2>

      {loading && (
        <div className="recent-parcels-loading">
          <span className="loading-spinner" />
          Ładowanie...
        </div>
      )}

      {error && <div className="recent-parcels-error">{error}</div>}

      {!loading && !error && parcels.length === 0 && (
        <div className="recent-parcels-empty">Brak działek do wyświetlenia</div>
      )}

      {!loading && !error && parcels.length > 0 && (
        <ul className="recent-parcels-list">
          {parcels.map((parcel) => (
            <li key={parcel.id}>
              <button
                className="recent-parcel-item"
                onClick={() => onParcelClick(parcel.id, parcel.lat, parcel.lng)}
              >
                <div className="recent-parcel-header">
                  <span className="recent-parcel-number">{parcel.parcel_number}</span>
                  {parcel.tender_type && (
                    <span className={`tender-type tender-type-${parcel.tender_type}`}>
                      {TENDER_TYPE_LABELS[parcel.tender_type] || parcel.tender_type}
                    </span>
                  )}
                </div>
                <div className="recent-parcel-details">
                  {parcel.commune && <span>{parcel.commune}</span>}
                  {parcel.price && <span className="recent-parcel-price">{formatPrice(parcel.price)}</span>}
                </div>
                <div className="recent-parcel-meta">
                  <span className="recent-parcel-source">{parcel.source_name}</span>
                  <span className="recent-parcel-time">{formatRelativeTime(parcel.created_at)}</span>
                </div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
